// Static fallback list of categories (used by Header/Footer when API not loaded yet).
// Source of truth for products is now the backend `/api/catalog` endpoint.

export const CATEGORIES = [
  { slug: "botox", name: "Botox", tagline: "Neurotoxin · Premium Korean & global brands" },
  { slug: "ha-filler", name: "HA Filler", tagline: "Hyaluronic acid dermal fillers" },
  { slug: "body-filler", name: "Body Filler", tagline: "Collagen biostimulators & body volumizers" },
  { slug: "lipolysis", name: "Lipolysis", tagline: "Fat dissolving solutions" },
  { slug: "skin-booster", name: "Skin Booster", tagline: "Hydration & rejuvenation injectables" },
  { slug: "exosome", name: "Exosome", tagline: "Next-gen regenerative therapy" },
  { slug: "iv-therapy", name: "IV Therapy", tagline: "Wellness & antioxidant infusions" },
  { slug: "lidocaine-cream", name: "Lidocaine Cream", tagline: "Topical anesthetic creams" },
  { slug: "etc", name: "Accessories", tagline: "Cannulas, hyaluronidase & supplies" },
];
